"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAsyncActionCreatorKey = createAsyncActionCreatorKey;
exports.createAsyncActionCreatorErrorOrFailValue = createAsyncActionCreatorErrorOrFailValue;
exports.createAsyncActionCreatorDataValue = createAsyncActionCreatorDataValue;
exports.createAsyncActionCreatorOptionalDataValue = createAsyncActionCreatorOptionalDataValue;
exports.createAsyncActionCreatorsMap = createAsyncActionCreatorsMap;
exports.createAsyncActionCreators = createAsyncActionCreators;
const ActionMethods_1 = require("../types/ActionMethods.js");
const lib_1 = require("../../lib/string/lib.js");
const lib_2 = require("../actionTypes/lib.js");
function createAsyncActionCreatorKey(options) {
    const { actionMethod, httpVerb, name } = options;
    const actionMethodLowercase = actionMethod.toLowerCase();
    const httpVerbCapialized = (0, lib_1.capitalize)(httpVerb.toLowerCase());
    const nameCapitalized = (0, lib_1.capitalize)(name);
    return `${actionMethodLowercase}${httpVerbCapialized}${nameCapitalized}`;
}
function createAsyncActionCreatorErrorOrFailValue(options) {
    const actionTypeValue = (0, lib_2.createAsyncActionTypeValue)(options);
    return function (errorOrFail) {
        const { statusCode } = errorOrFail;
        return {
            statusCode,
            type: actionTypeValue
        };
    };
}
function createAsyncActionCreatorDataValue(options) {
    const actionTypeValue = (0, lib_2.createAsyncActionTypeValue)(options);
    return function (data) {
        return {
            data,
            type: actionTypeValue
        };
    };
}
function createAsyncActionCreatorOptionalDataValue(options) {
    const actionTypeValue = (0, lib_2.createAsyncActionTypeValue)(options);
    return function (data) {
        if (data === undefined) {
            return {
                type: actionTypeValue
            };
        }
        return {
            data,
            type: actionTypeValue
        };
    };
}
function createAsyncActionCreatorTypeValue(options) {
    const actionTypeValue = (0, lib_2.createAsyncActionTypeValue)(options);
    return function () {
        return {
            type: actionTypeValue
        };
    };
}
function createAsyncActionCreatorsMap(options, defaultRequest) {
    const { receive, request } = options, rest = __rest(options, ["receive", "request"]);
    const originalRequest = !request || request === 'optional' ?
        createAsyncActionCreatorOptionalDataValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Request }, rest)) :
        createAsyncActionCreatorDataValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Request }, rest));
    let lastRequest = defaultRequest;
    const wrappedRequest = !request || request === 'optional' ?
        (actionRequest) => {
            lastRequest = actionRequest;
            return originalRequest(actionRequest);
        } :
        (actionRequest) => {
            lastRequest = actionRequest;
            return originalRequest(actionRequest);
        };
    const repeat = (transform) => {
        const previous = (lastRequest !== null && lastRequest !== void 0 ? lastRequest : defaultRequest);
        return wrappedRequest(transform ? transform(previous) : previous);
    };
    return {
        [ActionMethods_1.AsyncActionMethods.Error]: createAsyncActionCreatorErrorOrFailValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Error }, rest)),
        [ActionMethods_1.AsyncActionMethods.Failed]: createAsyncActionCreatorErrorOrFailValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Failed }, rest)),
        [ActionMethods_1.AsyncActionMethods.Receive]: receive ?
            createAsyncActionCreatorDataValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Receive }, options)) :
            createAsyncActionCreatorTypeValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Receive }, options)),
        [ActionMethods_1.AsyncActionMethods.Repeat]: repeat,
        [ActionMethods_1.AsyncActionMethods.Request]: wrappedRequest,
        [ActionMethods_1.AsyncActionMethods.Reset]: createAsyncActionCreatorTypeValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Reset }, rest))
    };
}
function createAsyncActionCreators(options, map) {
    const { receive, request } = options, rest = __rest(options, ["receive", "request"]);
    return {
        [createAsyncActionCreatorKey(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Error }, rest))]: map.error,
        [createAsyncActionCreatorKey(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Failed }, rest))]: map.failed,
        [createAsyncActionCreatorKey(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Receive }, rest))]: map.receive,
        [createAsyncActionCreatorKey(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Repeat }, rest))]: map.repeat,
        [createAsyncActionCreatorKey(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Request }, rest))]: map.request,
        [createAsyncActionCreatorKey(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Reset }, rest))]: map.reset
    };
}
//# sourceMappingURL=lib.js.map